/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {BaseComponent} from "@intuitionrobotics/thunderstorm/frontend";
import {COLORS} from "@res/colors";
import {FONTS} from "@res/fonts";


export class StatusDialog
	extends BaseComponent {

	statusExplanation = (status: string, description: string) => {
		return <div style={{padding: '5px'}}>
			{FONTS.bold_14_blue(status)}
			{FONTS.reg_14(description, {display: 'inline'})}
		</div>;
	};

	render() {
		return <div
			style={{backgroundColor: COLORS.white, width: 'max-content', padding: '10px', borderRadius: '4px'}}>
			{this.statusExplanation('Sent -', ` Message sent, but hasn’t been delivered to customer’s ElliQ yet`)}
			{this.statusExplanation('Received -', ` Message received to customer’s ElliQ, but wasn’t read yet`)}
			{this.statusExplanation('Failed -', ` Message failed to reach customer’s ElliQ`)}
			{this.statusExplanation('Read -', ` Customer read the message`)}
			{this.statusExplanation('Answered -', ` Customer replied to the message`)}
		</div>;
	}
}
